import type { Config } from 'dompurify';

/** Keep in sync with admin-frontend `sanitizeBannerHtml` allowlist (`i`, `b`, `strong`, `u`, `a`). */
export const LIVE_BANNER_PURIFY_CONFIG: Config = {
  ALLOWED_TAGS: ['b', 'i', 'strong', 'u', 'a'],
  ALLOWED_ATTR: ['href', 'target', 'rel'],
};
